import PageTitleHook from '../../../utils/PageTitleHook/PageTitleHook';
import { Button, SectionalAlert } from '../../baseComponents';
import { useContext } from 'react';
import { pathContext } from '../../../contexts/contexts';

export const MyUscisCapacity = () => {
  PageTitleHook('USCIS Online Account | My USCIS at Capacity');
  const { setUrl } = useContext(pathContext);

  return (
    <div className="flex justify-center bg-white py-8 px-8">
      <div className="w-900" data-testid="myuscis-capacity-container">
        <h1 className="text-3xl my-3 font-light text-dhs_font_gray">Please try again later...</h1>

        <br />
        <SectionalAlert type={'info-important'}>
          {'myUSCIS is currently experiencing a high volume of requests. Please try again later.'}
        </SectionalAlert>
        <br />

        <Button id="2fa-back-btn" text="Back" type="primary" onClick={() => setUrl('/sign-in')} />
      </div>
    </div>
  );
};
